import React from 'react';
import PropTypes from 'prop-types';

import { Modal, SplitContainer, Button } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Style from './swapSeatModal.module.css';
import SwapSeatList from './components/swapSeatList';
import SwapSeatMapCard from './components/swapSeatMapCard';
import SeatMapPopOver from './components/seatMapPopOver';
import SeatMapPopup from './components/seatMapPopup';
import { ReactComponent as Seat } from '@weezevent/throne/dist/images/seating/siege-available.svg';

//Render content popover with attendee or without
export function LabelSeatOver({ seat = {}, categories = {} }) {
    const { t } = useTranslation();

    if (!seat?.seat) {
        return null;
    }

    return (
        <>
            {seat.attendee ? (
                <div className={Style['popover__content']}>
                    <style>
                        {`
                            svg.seat-category-over {
                                width: 16px;
                                height: 15px;
                                margin-right: 3px;
                            }

                            svg.seat-category-over-${seat.seat.style.color.substring(1, seat.seat.style.color.length)} path {
                                fill: ${seat.seat.style.color};
                            }
                        `}
                    </style>
                    <div className={Style['icon-seat']}>
                        <Seat className={`seat-category-over ${'seat-category-over-' + seat.seat.style.color.substring(1, seat.seat.style.color.length)}`} />
                    </div>
                    <span>{t('ticket.swapSeat.popup.seatOccupied', { name: seat.attendee.attendee.resolved_attendee_name })}</span>
                </div>
            ) : (
                <div className={Style['popover__content']}>
                    <span className={Style['bullet']} style={{ backgroundColor: categories[seat.seat.category]?.color || '#CCCCCC' }} />
                    <span>
                        {t('ticket.common.seating.labelInfosSeating', {
                            row: seat.seat.row,
                            seat: seat.seat.seat,
                            access: seat.seat.access
                        })}
                    </span>
                </div>
            )}
        </>
    );
}

LabelSeatOver.propTypes = {
    seat: PropTypes.object,
    categories: PropTypes.object
};

export default function SwapSeatModal({
    show = false,
    onClose = () => {},
    availability = null,
    onAvailability = () => {},
    attendees = null,
    onChangeAttendees = () => {},
    attendeesSelected = {},
    handleAttendeeList = () => {},
    seatOver = null,
    onSeatOver = () => {},
    seatsSelected = [],
    onSeatsSelected = () => {},
    isSubmitting = false,
    onSubmit = () => {},
    categories = {}
}) {
    const { t } = useTranslation();

    return (
        <Modal className={Style['swap-seat-modal']} size="fullscreen" open={show} onClose={onClose} allowExternalClosing={false}>
            <SplitContainer
                className={Style['modal__split-container']}
                additional={
                    <SwapSeatList attendees={attendees} attendeesSelected={attendeesSelected} onClick={handleAttendeeList}>
                        <Button.Group>
                            <Button
                                disabled={!attendees.filter(attendee => attendee.new_seat).length}
                                fluid
                                primary
                                onClick={onSubmit}
                                label={t('ticket.common.action.continue')}
                            />
                            <Button fluid onClick={onClose} label={t(`ticket.common.action.cancel`)} />
                        </Button.Group>
                    </SwapSeatList>
                }
            >
                <SwapSeatMapCard
                    onClose={onClose}
                    attendees={attendees}
                    availability={availability}
                    onAvailability={onAvailability}
                    onSeatOver={onSeatOver}
                    onSeatsSelected={onSeatsSelected}
                    popover={
                        <SeatMapPopOver title={categories && categories[seatOver?.seat.category] ? categories[seatOver?.seat.category]?.name : ''}>
                            <LabelSeatOver seat={seatOver} categories={categories} />
                        </SeatMapPopOver>
                    }
                />
                <SeatMapPopup
                    seatsSelected={seatsSelected}
                    attendees={attendees}
                    onChangeAttendees={onChangeAttendees}
                    onSeatsSelected={onSeatsSelected}
                    handleAttendeeList={handleAttendeeList}
                />
            </SplitContainer>
        </Modal>
    );
}

SwapSeatModal.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    availability: PropTypes.object,
    onAvailability: PropTypes.func,
    attendees: PropTypes.array,
    onChangeAttendees: PropTypes.func,
    attendeesSelected: PropTypes.object,
    handleAttendeeList: PropTypes.func,
    seatOver: PropTypes.object,
    onSeatOver: PropTypes.func,
    seatsSelected: PropTypes.array,
    onSeatsSelected: PropTypes.func,
    isSubmitting: PropTypes.bool,
    onSubmit: PropTypes.func,
    categories: PropTypes.object
};
